/**
 * Типы дефекта по материалу зоны.
 *
 * Зеркало серверного справочника (backend/app/models/damage.py,
 * DAMAGE_TYPES_BY_MATERIAL). Расхождение ловится тестом
 * damageTypes.contract.test.js, который читает питоновский файл:
 * если списки разойдутся, водитель отправит тип, который сервер
 * не примет, и приёмка упрётся в 422 уже после съёмки фото.
 *
 * Список короткий и привязан к материалу намеренно: для тента
 * бессмысленна «вмятина», для сэндвич-панели будки — «порез».
 * Короткий уместный список вводится в одно касание и даёт
 * данные, по которым потом можно считать статистику.
 */

export const DAMAGE_TYPES_BY_MATERIAL = {
  metal: ['scratch', 'dent', 'chip', 'rust', 'deformation'],
  box_panel: ['dent', 'puncture', 'delamination', 'lock_broken', 'deformation'],
  tent: ['cut', 'tear', 'eyelet_missing', 'strap_torn'],
  glass: ['chip', 'crack', 'shattered'],
  wheel: ['cut', 'bulge', 'rim_damage'],
  plastic: ['scratch', 'crack', 'missing'],
}

export const DAMAGE_TYPE_LABELS = {
  scratch: 'Царапина',
  dent: 'Вмятина',
  chip: 'Скол',
  rust: 'Коррозия',
  deformation: 'Деформация',
  puncture: 'Пробой обшивки',
  delamination: 'Расслоение панели',
  lock_broken: 'Повреждён замок/запор',
  cut: 'Порез',
  tear: 'Разрыв',
  eyelet_missing: 'Отсутствует люверс',
  strap_torn: 'Оторван ремень',
  crack: 'Трещина',
  shattered: 'Разбито',
  bulge: 'Грыжа',
  rim_damage: 'Повреждён диск',
  missing: 'Отсутствует деталь',
}

export const SEVERITIES = [
  { value: 'critical', label: 'Ехать нельзя' },
  { value: 'minor', label: 'Не критично' },
]

export function damageTypesFor(material) {
  return DAMAGE_TYPES_BY_MATERIAL[material] || DAMAGE_TYPES_BY_MATERIAL.metal
}
